export const STORYBLOK_API_URL = 'https://api-us.storyblok.com/v2/cdn/stories'
export const STORYBLOK_DEV_ENVIRONMENTS = ['dev', 'rel', 'local']
